export default import.meta.ROLLDOWN_FILE_URL_RNTMAS8vSap0SvY08rMu8Q